var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"wrapper-footer",attrs:{"color":"primary"}},[_c('span',[_vm._v("Av. Jerônimo de Ornelas, 670 – Bairro Santana")]),_c('span',[_vm._v("CEP 900340-040 – Porto Alegre/RS")])])}
var staticRenderFns = []

export { render, staticRenderFns }